import React from 'react';

interface CustomDotProps {
  cx: number;
  cy: number;
  r?: number;
  fill?: string;
  borderColor?: string;
  onMouseEnter?: (e: React.MouseEvent<SVGElement, MouseEvent>) => void;
  onMouseLeave?: () => void;
  onClick?: (e: React.MouseEvent<SVGElement, MouseEvent>) => void;
}

export default function CustomDot({
  cx,
  cy,
  r = 8,
  fill = '#FF6347',
  borderColor = '#32CD32',
  onMouseEnter,
  onMouseLeave,
  onClick,
}: CustomDotProps) {
  if (isNaN(cx) || isNaN(cy)) return null;

  return (
    <svg
      x={cx - r - 3}
      y={cy - r - 3}
      width={r * 2 + 6}
      height={r * 2 + 6}
      viewBox='0 0 20 20'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      onClick={onClick}
    >
      <circle
        cx='10'
        cy='10'
        r='5'
        fill={fill}
        stroke={borderColor}
        strokeWidth='3'
      />
    </svg>
  );
}
